export default "__VITE_ASSET__DtmpAB_a__"